import { Redirect } from "react-router-dom";
import RouteWrapper from "./RouteWrapper";

import LayoutLogin from "components/Layout/LoginPage";
import Login from "pages/Login";

export default function AppRoutes() {
  return (
    <>
      <RouteWrapper exact path="/" component={Login} layout={LayoutLogin} />
      <Redirect from="*" to="/" />
    </>
  );
}
